import { Controller } from 'libraries/front-end-core/core/Router'
import getUrl from 'libraries/front-end-core/core/url'
import { MW_OVERVIEW } from 'constants/controllers'
import Main from 'redux/containers/pages/mwoverview/OverviewContainer'

export default new Controller({
  name: MW_OVERVIEW,
  route: '(:aol/)markets/overview',
  controller (
    Router,
    {
      url: pageId,
      pageView,
      params: { flavour }
    },
    render,
    state
  ) {
    const aol = 'corporate'
    render(
      { Main },
      { controller: MW_OVERVIEW, aol },
      {
        flavour,
        aol,
        pageId: getUrl(MW_OVERVIEW, { aol }),
        pageView,
        searchType: 'dealwatch',
        className: 'dealwatch'
      }
    )

    return pageId
  }
})
